import store from '../store'

export const LoginGuard = async (to, from, next) => {
  // アクセストークンをチェックする
  if (!store.getters['auth/accessToken']) {
    // アクセストークンが無ければ、ログイン画面へ
    return next({ name: 'Login' })
  }

  // 会員情報をチェックする
  const user = store.getters['auth/userInfo']
  if (!user) {
    // 会員情報を取得する
    // ※ アクセストークンの有効期限切れ = Axiosで401エラーが発生する
    await store.dispatch('auth/getUser')
    return next()
  }

  next()
}



// WEBPACK FOOTER //
// ./src/guards/login.guard.js